import React from 'react'
import { Link, Text } from 'components/ds'
import { useTranslation } from '@disco/i18n/use-translation'
type Props = {
  signupUrl?: string | null | undefined
  onClick: () => void
}

/**
 * SignUp component for displaying signup options
 *
 * Provides a link to sign up for a new account. Can either link to an external
 * signup URL or trigger an internal signup flow through the onClick callback.
 *
 * @param props - Component props
 * @param props.signupUrl - Optional external URL for signup (opens in new tab)
 * @param props.onClick - Callback function for internal signup flow
 * @returns JSX element containing the signup link
 */
const SignUp = ({ signupUrl, onClick }: Props): React.ReactNode => {
  const { t } = useTranslation('accounts')

  return (
    <Text align="center" size="2">
      {signupUrl ? (
        <span>{t('accounts:dontHaveDisco', 'Don’t have DISCO?')} </span>
      ) : (
        <>
          <span>
            {t('accounts:dontHaveAnAccount', 'Don’t have an account?')}
          </span>
          <br />
        </>
      )}
      <Link // color="tomato"
        // color="gray"
        href={signupUrl || '#'}
        target="_blank"
        onClick={e => {
          if (!signupUrl && onClick) {
            e.preventDefault()
            onClick()
          }
        }}
      >
        {signupUrl
          ? t('accounts:signUpHere', 'Sign up here')
          : t(
              'accounts:createAFreeDiscoCatalogAccount',
              'Create a free DISCO Catalog account',
            )}
      </Link>
    </Text>
  )
}

export default SignUp
